import { Tab } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTab = styled(Tab)`
  font-family: var(--default-fonts);
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5;
  text-transform: none;
  min-height: 48px;
  border-radius: 999px;
  color: #64748b;
  padding: 0.45rem 1rem;

  &.Mui-selected {
    color: #1841ff;
    background: #f8fafc;
  }
`;

export default StyledTab;
